import { CalendarClock, ClipboardList, CreditCard, Dumbbell, FileText, LayoutDashboard, Mail, Megaphone, ScrollText, Settings, Users } from "lucide-react";

export const adminNavItems = [
  { label: "Dashboard", path: "/admin", icon: LayoutDashboard, end: true },
  { label: "Programs", path: "/admin/programs", icon: Dumbbell },
  { label: "Memberships", path: "/admin/memberships", icon: CreditCard },
  { label: "Assessments", path: "/admin/assessments", icon: ClipboardList },
  { label: "Players", path: "/admin/players", icon: Users },
  { label: "Schedule", path: "/admin/schedule", icon: CalendarClock },
  { label: "Payments", path: "/admin/payments", icon: CreditCard },
  { label: "Content", path: "/admin/content", icon: FileText },
  { label: "Announcements", path: "/admin/announcements", icon: Megaphone },
  { label: "Leads", path: "/admin/leads", icon: Mail },
  { label: "Users", path: "/admin/users", icon: Users },
  { label: "Audit Log", path: "/admin/audit-log", icon: ScrollText },
  { label: "Settings", path: "/admin/settings", icon: Settings },
];
